<template>
  <button
    class="relative flex items-center justify-center w-full h-16 font-semibold text-white bg-blue-600 border-b-4 border-blue-800 rounded-lg shadow focus:outline-none text-shadow"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "DieButton",
};
</script>
